<div
	[class.items-center]="alignment() === 'center'"
	[class.mx-auto]="alignment() === 'center'"
	[class.text-center]="alignment() === 'center'"
	[class.text-left]="alignment() === 'left'"
	[editableInStoryblok]="_editable()"
	class="flex max-w-screen-md flex-col gap-4 md:gap-6"
>
	@if (topFigure()) {
		<svg-icon
			[src]="topFigure()"
			class="icon-container icon-container-xl icon-container-xl-full icon-container-accent shrink-0"
		/>
	}
	<sb-heading-group
		[alignment]="alignment()"
		[headingType]="headingType()"
		[isSection]="true"
		[overline]="overline()"
		[size]="size()"
		[title]="title()"
	/>
	@if (content()) {
		<markdown [data]="content()" class="text-base md:text-lg" />
	}
	@if (bottomFigure()) {
		<svg-icon
			[src]="bottomFigure()"
			class="icon-container icon-container-xl icon-container-xl-full icon-container-accent shrink-0"
		/>
	}
</div>
